const FEATURES = [
  {
    icon: 'ri-flashlight-line',
    title: '第一手爆料',
    desc: '全网爆料内容火速追踪，热点首发先人一步。每日爆料大赛汇聚真实线人，确保信息新鲜度领先同行。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '多方核实',
    desc: '每条爆料经多人交叉验证后发布，标注可信度等级。真实爆料优先推荐，虚假信息即时标注下架。',
  },
  {
    icon: 'ri-group-line',
    title: '万人吃瓜',
    desc: '18万+活跃吃瓜群众实时讨论互动，爆料评论区热度爆表。你的每一条评论都可能推动真相浮出水面。',
  },
  {
    icon: 'ri-trophy-line',
    title: '爆料大赛',
    desc: '每日爆料大赛排名实时更新，热门参赛作品角逐周榜与月榜。优秀爆料者可获得专属认证与流量扶持。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-3">平台优势</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">
          为什么选择每日爆料？我们用实力说话
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {FEATURES.map((f, i) => (
            <div
              key={i}
              className="group p-6 rounded-xl bg-background-100 hover:bg-background-100/80 border border-background-200/60 transition-all cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-500 mb-4 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${f.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}